import { render, staticRenderFns } from "./PostalCodeRangeQuantityRangeEditDialog.vue?vue&type=template&id=33985896&scoped=true"
import script from "./PostalCodeRangeQuantityRangeEditDialog.vue?vue&type=script&lang=js"
export * from "./PostalCodeRangeQuantityRangeEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33985896",
  null
  
)

export default component.exports